import extend from "extend";
import axios from "axios";
import qs from "qs";
import store from "store";
import { invalidSession } from "js/util/util.js";
import { Message } from "element-ui";
import Cookie from "js-cookie";
// axios.defaults.baseURL = 'http://172.16.52.243:80'
try {
    axios.defaults.baseURL = baseConfigUrl;
} catch (e) {
    axios.defaults.baseURL = location.href;
}
axios.defaults.withCredentials = true;

const netApi = axios.create({
    // withCredentials: true,
    // paramsSerializer: function (params) {
    //     return qs.stringify(params, { arrayFormat: 'brackets' })
    // },
});
// document.cookie = "language=" + store.state.lenovoData.language;
netApi.interceptors.response.use(
    res => res,
    error => {
        try {
            if (
                error.response.status == 401 &&
                window.location.href.indexOf("/login") == -1
            ) {
                sessionStorage.removeItem("store");
                sessionStorage.removeItem("denglu");
                Cookie.remove("X-LENOVO-SESS-ID");
                window.location.href = "/login";
            }
        } catch (e) {
            console.log(e);
        }

        try {
            if (document.querySelector(".el-message--error")) {
                Message.closeAll();
            }
        } catch (e) {
            console.log(e);
        }
        return Promise.reject(error);
        // if (error.response && error.response.status === 401) {
        //     //invalidSession();
        // } else {
        //
        // }
    }
);

// 拦截器，处理断网情况
netApi.interceptors.request.use(
    config => {
        // console.log(store.state.lenovoData.userInfo['X-LENOVO-SESS-ID'],33144);
        // if(store.state.lenovoData.userInfo['X-LENOVO-SESS-ID']){
        //     config.headers.common['Cookie'] = `X-LENOVO-SESS-ID=${store.state.lenovoData.userInfo['X-LENOVO-SESS-ID']}`
        // }
        if (!navigator.onLine) {
            return Promise.reject({
                code: 600,
                message: "offline"
            });
        }
        if (config.url === "/v2/odc/get_belong_to_teams") {
            //这个接口转换下格式
            config.paramsSerializer = function(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            };
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
const VERSION = "/v2";
const URL = {
    getUserInfo: "/user/info/get",
    getAccountInfo: "/account/info/get",
    getCustomizeInfo: "/account/funs/get",
    getAccountConfig: "/config/getAccountConfig", //获取账户默认信息
    getSession: "/account/getsess", //获取Session
    getDcList: "/dc/clouddc/getDcList", //获取所有的数据中心列表
    //日志管理
    getLogInfo: "/log/get", //获取日志列表
    getUserSearch: "/suggestion", //用户查找
    getOperationType: "/log/get_operation_type", //获取操作类型动作
    //日志定时导出
    getLogExportListInfo: "/logexport/list/get", //日志定时导出状态获取
    setLogExportListInfo: "/logexport/list/set", //设置日志定时导出状态
    getLogExportList: "/logexport/list", //日志定时导出列表获取
    setLogExportDelete: "/logexport/delete", //日志定时导出文件删除
    getLogExportDownload: "/logexport/download", //日志定时导出下载
    //团队
    // 各种配置获取：最长有效期等
    getConfig: "/config/get",
    setConfig: "/config/set",
    getMetadata: "/metadata/databox", //获取文件列表
    getEntFolders: "/meta_list/databox", //企业版目录
    //文件模板
    tempCategroy: "/template/category/list", //文件模板类型列表
    tempCategroyUpdate: "/template/category/update", //更新模板类型
    tempCategroyDelete: "/template/category/delete", //删除模板类型
    tempCategroyCreate: "/template/category/create", //创建模板类型
    tempFile: "/template/file/list", //获文件模板列表
    tempFileCreate: "/template/file/create", //创建文件模板
    tempFileDelete: "/template/file/delete", //删除文件模板
    tempFileDetail: "/template/file/detail", //文件模板信息
    tempFileUpdate: "/template/file/update", //更新文件模板
    tempFilePreview: "/template/file/preview", //文件模版预览
    //离线文档管控
    getOrSetOdcRule: "/odc/rule",
    setOdcConsole: "/odc/console",
    searchUserTeam: "/user_team/search", // 搜索团队和成员
    searchUser: "/user/list", //搜索成员
    getTeamListById: "/team/list_by_id", //获取团队
    userListForPages: "/user/list_for_pages", //获取所有用户,搜索用户
    teamListForPages: "/user_team/list_for_pages", //搜索团队
    listByResource: "/auth/list_by_resource",
    createOdcRule: "/odc/rule/create", //新建管控规则
    deleteOdcRule: "/odc/rule/delete",
    modifyOdcRule: "/odc/rule/modify", //更新规则
    getRuleList: "/odc/rule/list", //规则列表
    getSingleRule: "/odc/rule/get", //获取单一规则
    checkExist: "/odc/check_exist", //管控对象是否存在
    getBelongTeams: "/odc/get_belong_to_teams", //获取用户所属团队
    // edas
    agentQuery: "/gl/edas/agent/query", //代理服务配置
    agentCreat: "/gl/edas/agent/create", //agent创建接口
    agentOperate: "/gl/edas/agent/operate", //agent操作接口
    syncConfig: "/gl/edas/config/sync", //同步配置操作接口
    syncMode: "/gl/edas/config/syncMode", //获取同步方式
    syncConfigList: "/gl/edas/config/syncs", //获取导入服务配置列表
    syncExecute: "/gl/edas/sync/execute", //立即同步接口
    syncStatus: "/gl/edas/config/syncStatus", //获取同步状态
    getEdasLog: "/gl/edas/log/statistic", //获取导入日志
    getEdasLogDetail: "/gl/edas/log/search", //获取edas日志详情
    exportEdasLog: "/gl/edas/log/export", //导出edas单条日志
    filterList: "/gl/edas/filter/listForPages", //过滤条件列表
    filterConfig: "/gl/edas/filter/rule", //添加过滤条件,删除过滤条件
    batchImportFilteringRule: "/gl/edas/filter/import/", //批量导入过滤条件
    authConfigList: "/gl/edas/auth/configs", //获取登录认证服务配置列表
    scanConfigList: "/gl/edas/qrcode/configs", //wxdingding获取登录认证服务配置列表
    ssoConfigList: "/gl/edas/sso/configs", //wxdingding单点登录配置列表
    authConfig: "/gl/edas/auth/config", //导入服务配置操作
    scanConfig: "/gl/edas/qrcode/config", //wxdingding导入服务配置操作
    ssoConfig: "/gl/edas/sso/config", //wxdingding导入服务配置操作
    getcaptcha: "/gl/edas/getcaptcha",
    getPublickey: "/gl/edas/get_publickey",
    edasLogin: "/gl/edas/login",
    //团队
    getTeamListByUser: "/team/list_by_user/",
    extraMeta: "/extra_meta", //获取标签
    bindingConfig: "/gl/edas/bind/role", //新增、修改、获取、删除绑定规则
    bindingConfigList: "/gl/edas/bind/roles", //查询绑定规则
    bindingExecute: "/gl/edas/bind/execute", //立即执行绑定同步
    bindingStatus: "/gl/edas/bind/executeStatus", //获取立即同步状态
    getBindLog: "/gl/edas/bind/log/statistic", //绑定日志统计
    getBindLogDetail: "/gl/edas/bind/log/search", //获取日志详情

    //管理员角色
    manageRoleList: "/manage/role/list",
    manageRoleDetail: "/manage/role/detail",
    searchTeamList: "/user_team/list_for_pages", //搜索团队
    //团队用户
    userFreeze: "/user/freeze", //单用户冻结
    userBatchFreeze: "/user/batch_freeze", //批量用户冻结
    userBatchUnFreeze: "/user/batch_unfreeze", //批量用户解冻
    userBatchDelete: "/user/batch_delete",
    sendActMail: "/user/batch_resendactmail", //发送激活邮件
    getUserDirectTeam: "/team/list_direct_belong_to_team", //用户直属团队
    userDelete: "/user/delete", //删除用户
    userModifySlug: "/user/modify_slug/", //修改用户邮箱
    userBatchSetInfo: "/user/batch_set_info", //批量设置
    //组织
    orgList: "/org/list",
    orgCreate: "/org/create", //创建组织
    orgDelete: "/org/delete/", //删除组织
    orgDimiss: "/org/dismiss/", //解散组织
    orgUpdate: "/org/set/", //更新组织
    orgSearch: "/org/search", //搜索组织
    orgUserSearch: "/orguser/search", //搜索组织和用户
    orgGet: "/org/get/", //获取组织信息
    // 组织用户
    orgUserList: "/orguser/list",
    userCreate: "/orguser/create", //创建用户
    orgUserBatchDelete: "/orguser/batch_delete", //删除组织用户
    addOrgMember: "/orguser/add_member/", //添加现有用户
    getOrgUserInfo: "/orguser/info/get/", //获取用户信息
    setOrgUserInfo: "/orguser/set/", //设置用户信息
    getUserDirectOrg: "/orguser/direct_belong_to_org", //用户直属组织
    getUserShowOrder: "/user/list_for_pages/order", //获取/设置用户自定义显示顺序
    //管理员列表
    getAdminList: "/manage/admin/list", //获取管理员列表
    createAdmin: "/manage/admin/create", //创建管理员
    updateAdmin: "/manage/admin/update", //编辑管理员
    roleOutline: "/manage/role/outline", //角色的权限概要
    getUserRole: "/manage/user/role", //获取用户角色
    deleteAdmin: "/manage/admin/delete", //删除管理员
    getUserBelongTeam: "/team/list_for_doc", //查询用户所在团队列表
    //权限移交
    authBatch: "/auth/list_by_batch_resource", //文件夹共享
    authTransfer: "/auth/transfer", //移交授权
    authListByOperator: "/auth/list_by_operator", //操作人id operator 授权类型grant_type 0:授权 ，1:分享，默认为1
    //链接安全管控
    deliveryManagementSetting: "/deliverymanagementsetting/globalrule",
    searchDir: "/fts_search",
    deliveryManagementRule: "/deliverymanagementsetting/rule",
    getDeliverySettingRules: "/deliverymanagementsetting/rules",
    whiteList: "/deliverymanagementsetting/globalrule/whitelist",
    getMetaByTeamAdmin: "/teamadmin/manage/folders",
    //融合云 数据同步
    getSynchcenter: "/synchcenter/task/list",
    updateSynchcenter: "/synchcenter/task/update/",
    deleteSynchcenter: "/synchcenter/task/delete/",
    createSynchcenter: "/synchcenter/task/create",
    getSynchcenterLog: "/synchcenter/task/logs/",
    getSynchcenterStatistic: "/synchcenter/modules/statistic",
    getSyncTaskSearch: "/sync/task/search",
    getSyncRegionGet: "/sync/region/get",
    getSynchcenterTask: "/synchcenter/task/dc/list",
    getSynchcenterTaskDetail: "/synchcenter/task/detail/",
    checkApproval: "/user/checkappsbeforeops",
    pluginManager: "/gl/plugin/manager",
    listData: "/gl/plugin/managers",
    managerStart: "/gl/plugin/manager/start",
    managerStop: "/gl/plugin/manager/stop",
    managersStart: "/gl/plugin/managers/start",
    managersStop: "/gl/plugin/managers/stop",
    managersDel: "/gl/plugin/managers/del",
    //应用管理 第三方应用
    createApp: "/apimanage/client",
    getApp: "/apimanage/client",
    getAllApp: "/apimanage/client",
    modifyAPP: "/apimanage/client",
    delApp: "/apimanage/client",
    getAppRate: "/apimanage/client",
    modifyAppRate: "/apimanage/client",
    getFunctionList: "/apimanage/function",
    getPermissionList: "/apimanage/client",
    getManageCategory: "/apimanage/category",
    getAppAvatarById: "/apimanage/client",
    checkAppName: "/apimanage/client",
    modifyManageCategory: "/apimanage/client_access?_method=put",
    getConfig: "/apimanage/control",
};
export default {
    get(url, params, done, error, options) {
        return netApi.get(VERSION + url).then(done, error);
    },
    getData(url, params, done, error, options) {
        let u,
            opt = null;
        const DEFAULT = {
            account_id: store.getters.accountId,
            uid: store.getters.uId,
            "X-LENOVO-SESS-ID": store.getters.session_id,
            _: Date.parse(new Date())
        };
        if (params === null) {
            u = URL[url];
            params = DEFAULT;
        } else {
            u = params.url ? URL[url] + params.url : URL[url];
            if (params.url) delete params.url;
            params = Object.assign({}, params, DEFAULT);
        }
        opt = extend(true, {}, options, { params });
        return netApi.get(VERSION + u, opt).then(done, error);
    },
    // 可以终止的get请求
    getDataAbort(url, params, options) {
        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        let u,
            opt = null;
        let DEFAULT = {
            account_id: store.getters.accountId,
            uid: store.getters.uId,
            "X-LENOVO-SESS-ID": store.getters.session_id,
            _: Date.parse(new Date())
        };
        // 路径可能并不是以当前域名开头，如果不是，以传入的参数为准
        let vu = URL[url] ? VERSION + URL[url] : url;
        if (params == null) {
            u = vu;
            params = DEFAULT;
        } else {
            u = params.url ? VERSION + URL[url] + encodePath(params.url) : vu;

            if (params.url) delete params.url;
            params = Object.assign({}, params, DEFAULT);
        }
        opt = extend(true, {}, options, { params });
        opt.cancelToken = source.token;
        let action = axios.get(u, opt);
        return { source, action };
    },
    getDataWithOption(url, params, done, error, options) {
        let u,
            opt = null;
        const DEFAULT = {
            account_id: store.getters.accountId,
            uid: store.getters.uId,
            "X-LENOVO-SESS-ID": store.getters.session_id,
            _: Date.parse(new Date())
        };
        if (params === null) {
            u = URL[url];
            params = DEFAULT;
        } else {
            u = params.url ? URL[url] + params.url : URL[url];
            if (params.url) delete params.url;
            params = Object.assign({}, params, DEFAULT);
        }
        if (options) {
            u += "/" + options;
        }
        opt = extend(true, {}, options, { params });
        return netApi.get(VERSION + u, opt).then(done, error);
    },
    getDataWithPath(url, path, params, done, error, options) {
        let getMapping = "";
        if (params && params.filename) {
            getMapping = VERSION + URL[url] + path + "/" + params.filename;
        } else {
            getMapping = VERSION + URL[url] + path;
        }
        delete params["path"];
        delete params["filename"];
        let opt = extend(true, {}, options, { params });
        return netApi.get(getMapping, opt).then(done, error);
    },
    getDataNoVersion(url, params, done, error, options) {
        let opt = extend(true, {}, options, { params });
        return netApi.get(URL[url], opt).then(done, error);
    },
    post(url, data, done, error, options) {
        return axios({
            method: "post",
            url: VERSION + URL[url],
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            data: data
        }).then(done, error);
        //return netApi.post(VERSION + URL[url],data).then(done, error)
    },
    postDataById(url, urlParams, data, done, error, options) {
        const DEFAULT = {
            account_id: store.getters.accountId,
            uid: store.getters.uId,
            "X-LENOVO-SESS-ID": store.getters.session_id,
            _: Date.parse(new Date())
        };
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt, DEFAULT);
        return netApi
            .post(VERSION + URL[url] + urlParams, data, {
                params: opt,
                headers: { "Content-Type": "application/json;charset=UTF-8" }
            }).then(done, error);
    },
    postDataByIdAuth(url, urlParams, data, done, error, options) {
        const DEFAULT = {
            account_id: store.getters.accountId,
            uid: store.getters.uId,
            "X-LENOVO-SESS-ID": store.getters.session_id,
            _: Date.parse(new Date())
        };
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt, DEFAULT);
        return netApi
            .post(VERSION + URL[url] + urlParams, data, { params: opt })
            .then(done, error);
    },
    postMg(url, data, done, error, options) {
        return axios({
            method: "post",
            url: VERSION + URL[url],
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            },
            data: data
        }).then(done, error);
        //return netApi.post(VERSION + URL[url],data).then(done, error)
    },
    postFormuts(url, data, done, error, options) {
        return axios({
            method: "post",
            url:
                VERSION +
                URL[url] +
                "?X-LENOVO-SESS-ID=" +
                store.getters.session_id,
            headers: {
                "Content-Type": "multipart/form-data"
            },
            data: data
        }).then(done, error);
        //return netApi.post(VERSION + URL[url],data).then(done, error)
    },
    postData(url, data, done, error, options) {
        const DEFAULT = {
            account_id: store.getters.accountId,
            uid: store.getters.uId,
            "X-LENOVO-SESS-ID": store.getters.session_id,
            _: Date.parse(new Date())
        };
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt, DEFAULT);
        return netApi
            .post(VERSION + URL[url], data, { params: opt })
            .then(done, error);
    },
    postDataWithoutQuery(url, data, done, error, options) {
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt);
        return netApi
            .post(VERSION + URL[url], data, { params: opt })
            .then(done, error);
    },
    putData(url, data, done, error, options) {
        const DEFAULT = {
            account_id: store.getters.accountId,
            uid: store.getters.uId,
            "X-LENOVO-SESS-ID": store.getters.session_id,
            _: Date.parse(new Date())
        };
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt, DEFAULT);
        return axios.put(VERSION + URL[url], data);
        // return netApi.put(VERSION + URL[url], data, {params: opt}).then(done, error)
    },
    putMgData(url, params, data, done, error, options) {
        return axios({
            method: "put",
            url: VERSION + URL[url] + params,
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            },
            data: data
        }).then(done, error);
        //return axios.put(VERSION + URL[url]+params, data)
        // return netApi.put(VERSION + URL[url], data, {params: opt}).then(done, error)
    },
    postDataWithId(url, data, done, error, options) {
        let opt = extend(true, {}, options),
            putURL = "";
        if (opt.type === "switcher") {
            putURL = VERSION + URL[url] + `/${opt.id}/` + opt.suffix;
        } else {
            putURL = VERSION + URL[url] + `/${opt.id}`;
        }
        return netApi.post(putURL, data, opt).then(done, error);
    },
    /**
     * @param url_tail 以post方式提交时映射地址后面所需的一系列get方式的参数
     */
    uploadDataWithUrlTail(url, url_tail, data, done, error, options) {
        let opt = extend(true, {}, options);
        return upload
            .post(VERSION + URL[url] + url_tail, data, opt)
            .then(done, error);
    },
    postDataWithUrlTail(url, url_tail, data, done, error, options) {
        url_tail += "&X-LENOVO-SESS-ID=" + store.getters.session_id;
        let opt = extend(true, {}, options);
        return netApi
            .post(VERSION + URL[url] + url_tail, data, opt)
            .then(done, error);
    },

    /**
     * 用 DataFrom 格式 post 数据
     * @param url
     * @param data 对象格式 {key: value}
     * @param options 配置
     * @returns {*}
     */
    postDataByDataForm(url, data, options, params) {
        if (options) {
            if (options.useBrackets) {
                data = qs.stringify(data, { arrayFormat: "brackets" });
            } else if (options.useRepeat) {
                data = qs.stringify(data, { arrayFormat: "repeat" });
            } else {
                data = qs.stringify(data);
            }
        } else {
            data = qs.stringify(data);
        }
        let u =
            options && options.urlParam
                ? URL[url] + options.urlParam
                : URL[url];
        return netApi.post(VERSION + u, data, params);
    },
    /**
     * delete方式删除数据
     */
    deleteData(url, url_tail, data, done, error, options) {
        url_tail += "&X-LENOVO-SESS-ID=" + store.getters.session_id;
        return netApi
            .delete(VERSION + URL[url] + url_tail, data)
            .then(done, error);
    },
    deleteMgData(url, url_tail, data, done, error, options) {
        return netApi
            .delete(VERSION + URL[url] + url_tail, data)
            .then(done, error);
    },
    deleteDataWithOption(url, params, done, error, options) {
        let u,
            opt = null;
        const DEFAULT = {
            account_id: store.getters.accountId,
            uid: store.getters.uId,
            "X-LENOVO-SESS-ID": store.getters.session_id,
            _: Date.parse(new Date())
        };
        if (params === null) {
            u = URL[url];
            params = DEFAULT;
        } else {
            u = params.url ? URL[url] + params.url : URL[url];
            if (params.url) delete params.url;
            params = Object.assign({}, params, DEFAULT);
        }
        if (options) {
            u += "/" + options;
        }
        opt = extend(true, {}, options, { params });
        return netApi.delete(VERSION + u, opt).then(done, error);
    },
    baseURL(url) {
        return axios.defaults.baseURL + VERSION + URL[url];
    }
};



// WEBPACK FOOTER //
// ./static/js/api/getdata.js